export enum EDeviceCategory {
    Gateway = 1,
    SubGateway = 2,
    Thermostat = 3,
    HomeAutomation = 4,
    AlarmSystem = 5,
    IntercomSystem = 6,
    Automation = 7,
    Virtual = 8
}

export class DeviceCategory {
    Id: number;
    Name: string;
}

export const DeviceCategories: DeviceCategory[] = [
    { Id: 1, Name: 'Gateway' },
    { Id: 2, Name: 'SubGateway' },
    { Id: 3, Name: 'Thermostat' },
    { Id: 4, Name: 'HomeAutomation' },
    { Id: 5, Name: 'AlarmSystem' },
    { Id: 6, Name: 'IntercomSystem' },
    { Id: 7, Name: 'Automation' },
    { Id: 8, Name: 'Support' }
];
